export default __webpack_public_path__ + "242e98c02e68cd6329078abd0466ced7.png";